export const googleauthcredentials = {
    "clientId" : "447690998141-ds6la8ppddmmqnan8dinrjs91c48poh9.apps.googleusercontent.com"
}